var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLongArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 42 24",
    height: "24px",
    viewBox: "0 0 42 24",
    width: "42px",
    fill: "#04246a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,19l1.41-1.41L5.83,13H40V11H5.83l4.59-4.59L9,5l-7,7L9,19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLongArrowLeft);
export default __webpack_public_path__ + "static/media/icon_long_arrow_left.e7db4c92c1739752f7983f287f7d1c08.svg";
export { ForwardRef as ReactComponent };